import React from 'react'
import FormField from '../FormField'
// import { validate } from './validate'
import { useDispatch, useSelector } from 'react-redux'
import type { UnknownAction } from 'redux'

export type FormModel = {
  getItem: (pk: unknown) => (state: unknown) => unknown
  getItemValue: (
    pk: unknown,
    name?: string,
  ) => (state: unknown) => { value?: unknown }
  change: (payload: Record<string, unknown>) => UnknownAction
}

type ModelOwnProps = {
  model: FormModel
  pk?: unknown
  name?: string
}

type ModelFormFieldProps = Record<string, any> &
  ModelOwnProps & {
    gridArea?: boolean
    errors?: string[]
    isDirty?: boolean
    validators?: unknown
    defaultValue?: unknown
  }

const ModelFormField = ({
  model,
  pk,
  name,
  gridArea = false,
  errors,
  isDirty,
  validators,
  value: _value,
  defaultValue,
  ...props
}: ModelFormFieldProps) => {
  const selectValue = React.useMemo(
    () => model.getItemValue(pk, name),
    [model, pk, name],
  )
  const { value } = useSelector(selectValue)
  const dispatch = useDispatch()
  const setValue = value =>
    dispatch(model.change({ pk, [String(name)]: value }))
  // const validator = validate(validators, props)
  const changeHandler = e => {
    const value = e?.target?.value ?? null
    // const err = errors.length ? validator(value) : errors
    // const action = { value, errors: err }
    setValue(value)
  }
  React.useEffect(() => {
    if (defaultValue && value == null) {
      setValue(defaultValue)
    }
    // eslint-disable-next-line
  }, [defaultValue])
  // Pinned, not endorsed: this sets a key named 'style, gridArea', not
  // style.gridArea, so the grid area never reaches the field.
  if (gridArea) props = { ...props, 'style, gridArea': name }

  return (
    <FormField
      name={name}
      value={value || ''}
      onChange={changeHandler}
      errors={errors}
      {...props}
    />
  )
}

export default ModelFormField
